import React from 'react';
import { TextField as MuiTextField, Box, Typography } from '@mui/material';

const CustomTextField = ({
    label,
    placeholder,
    name,
    error,
    required = false,
    customHelper = null,
    sx = {},
    ...props
}) => {
    const isMultiline = props.multiline;

    return (
        <Box sx={{ width: '100%', ...sx }}>
            {label && (
                <Typography variant="body2" mb={1}>
                    {label}
                    {required && <span style={{ color: 'red' }}> *</span>}
                </Typography>
            )}

            <MuiTextField
                fullWidth
                placeholder={placeholder}
                name={name}
                   error={!!error}
                     helperText={error || ""} 
                variant="outlined"
                size="small"
                {...props}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        ...(isMultiline ? {} : { height: '44px' }),
                        '& input': {
                            padding: '10px 8px 10px 12px',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#E1E1E1',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#E1E1E1',
                        },
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E1E1E1',
                        borderRadius: '8px',
                    },
                }}
            />

            {customHelper && (
                <Typography
                    variant="body2"
                    color="#A1A1A1"
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 0.5,
                        mt: 1,
                    }}
                >
                    {customHelper}
                </Typography>
            )}
        </Box>
    );
};

export default CustomTextField;
